export { default as GastoGrid } from './Listar';
export { default as GastoCrear } from './crear';
export { default as GastoDetalle } from './Detalle';
